import { dcAuthApi } from '../apiBase';

export interface TenantRosterMember {
  id: string;
  name: string;
  email: string;
  username?: string;
  role: 'admin' | 'member';
}

interface RosterDto {
  id: string;
  name: string;
  email: string;
  username?: string | null;
  role: 'admin' | 'member';
}

interface AddTenantUserDto {
  user_id: string;
  name: string;
  email: string;
  username: string;
  role: 'admin' | 'member';
  created: boolean;
  keycloak_created: boolean;
}

export interface AddTenantUserPayload {
  email: string;
  name: string;
  username?: string;
  role: 'admin' | 'member';
  createInKeycloak?: boolean;
  password?: string;
}

export interface AddTenantUserResult {
  userId: string;
  name: string;
  email: string;
  username: string;
  role: 'admin' | 'member';
  created: boolean;
  keycloakCreated: boolean;
}

function mapRosterMember(dto: RosterDto): TenantRosterMember {
  return {
    id: dto.id,
    name: dto.name,
    email: dto.email,
    username: dto.username ?? undefined,
    role: dto.role,
  };
}

export const memberApi = {
  async getRoster(tenantId: string): Promise<TenantRosterMember[]> {
    const response = await dcAuthApi.get<RosterDto[]>(`/tenants/${tenantId}/roster`);
    return response.data.map(mapRosterMember);
  },

  async addUser(tenantId: string, payload: AddTenantUserPayload): Promise<AddTenantUserResult> {
    const response = await dcAuthApi.post<AddTenantUserDto>(`/tenants/${tenantId}/users`, {
      email: payload.email,
      name: payload.name,
      username: payload.username,
      role: payload.role,
      create_in_keycloak: payload.createInKeycloak ?? true,
      password: payload.password,
    });
    const dto = response.data;
    return {
      userId: dto.user_id,
      name: dto.name,
      email: dto.email,
      username: dto.username,
      role: dto.role,
      created: dto.created,
      keycloakCreated: dto.keycloak_created,
    };
  },

  async removeAdmin(tenantId: string, userId: string): Promise<void> {
    await dcAuthApi.delete(`/tenants/${tenantId}/admins/${userId}`);
  },

  async removeMember(tenantId: string, userId: string): Promise<void> {
    await dcAuthApi.delete(`/tenants/${tenantId}/members/${userId}`);
  },
};
